import { Box, Button, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { COUNTRY_FLAG_ICON } from '@configs/language/config';
import { Currency } from '@configs/language';
import WalletCardSkeleton from '@efex-components/common/Skeleton/WalletCardSkeleton';
import useOpenIntercomService from '@pages/inactiveUser/hooks/useOpenIntercomService';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import creatingAccountStyles from './CreatingAccount.style';
import useCreateAccount from './hooks/useCreateAccount';
import { CreatingAccountProps } from './types/CreatingAccount.types';

const CreatingAccount = ({
  selectedCurrency,
  onGoToNextStep,
}: CreatingAccountProps) => {
  const { error, isCreatingWallet, createWallet } = useCreateAccount({
    selectedCurrency,
    onGoToNextStep,
  });

  const { showNewMessage } = useOpenIntercomService();

  const { t } = useTranslation();

  return (
    <Box className={creatingAccountStyles.wrapper}>
      <Typography variant="h6" align="center">
        {t('creatingGlobalAccountTitle', {
          currencyName: selectedCurrency.currencyName,
        })}
      </Typography>

      <Box className={creatingAccountStyles.content}>
        {isCreatingWallet && (
          <>
            <WalletCardSkeleton
              currencyImg={
                COUNTRY_FLAG_ICON[selectedCurrency.currency as Currency]
              }
              showProgressBar
            />

            <Button variant="outlined">{t('cancelButton')}</Button>
          </>
        )}

        {error && (
          <>
            <Box className={creatingAccountStyles.errorContainer}>
              <ReportProblemIcon />

              <Typography variant="body2" align="center">
                {t('creatingGlobalAccountErrorTitle')}
              </Typography>

              <Typography variant="caption" align="center">
                <Trans i18nKey="creatingGlobalAccountErrorDescription">
                  <button
                    type="button"
                    aria-label={
                      t('creatingGlobalAccountErrorDescription') as string
                    }
                    onClick={() => {
                      showNewMessage(
                        t('intercomErrorCreatingWallet', {
                          currencyName:
                            selectedCurrency.currencyName.toLowerCase(),
                        }) as string
                      );
                    }}
                  />
                </Trans>
              </Typography>
            </Box>

            <Button variant="outlined" onClick={createWallet}>
              {t('tryAgainButton')}
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default CreatingAccount;
